<template>
    <div class="home-content">
        <MainContent />
    </div>
</template>

<script>
import MainContent from '@/components/MainContent/index.vue'

export default {
    components:{
        MainContent
    }
        
    
}
</script>

<style type="text/css">

</style>